import Vue from 'vue'
import Router from 'vue-router'
import HW from '@/components/HelloWorld'
import Manage from '@/components/Manage'
import index from '@/components/manage/index'
import infoList from '@/components/manage/infoList'
import productList from '@/components/manage/productList'
import hitList from '@/components/manage/hitList'
import downloadList from '@/components/manage/downloadList'
import exhibitionList from '@/components/manage/exhibitionList'
import reserveList from '@/components/manage/reserveList'
import productDetail from '@/components/manage/productDetail'
import infoDetail from '@/components/manage/infoDetail'
import opinion from '@/components/manage/opinion'
import productAdd from '@/components/manage/productAdd'
import password from '@/components/manage/password'
import exhibitionDetail from '@/components/manage/exhibitionDetail'
import ex_user from '@/components/manage/ex_user'
import admin_ex_user from '@/components/admin/ex_user'


// 管理员后台 路由
import Admin from '@/components/Admin'
import admin_index from '@/components/admin/index'
import admin_companyList from '@/components/admin/companyList'
import admin_productList from '@/components/admin/productList'
import admin_viewerList from '@/components/admin/viewerList'
import admin_activityList from '@/components/admin/activityList'
import admin_addActivity from '@/components/admin/addActivity'
import admin_ActivityApply from '@/components/admin/activityApply'
import admin_addStationInfo from '@/components/admin/addStationInfo'
import admin_accountManage from '@/components/admin/accountManage'
import admin_applyBooth from '@/components/admin/applyBooth'
import admin_exhibitorDetails from '@/components/admin/exhibitorDetails'
import admin_productDetail from '@/components/admin/productDetail'
import admin_eventManage from '@/components/admin/eventManage'
import admin_eventContent from '@/components/admin/eventContent'
import admin_eventTrip from '@/components/admin/eventTrip'
import admin_eventInfo from '@/components/admin/eventInfo'
import admin_eventRoute from '@/components/admin/eventRoute'
import admin_eventContact from '@/components/admin/eventContact'
import admin_eventDownload from '@/components/admin/eventDownload'
import admin_adManage from '@/components/admin/adManage'
import admin_product_vote from '@/components/admin/product_vote'
import admin_viewerDetail from '@/components/admin/viewerDetail'
import admin_activityDatail from '@/components/admin/activityDatail'
import admin_eventMangeDetail from '@/components/admin/eventMangeDetail'
import admin_stationInfoDetail from '@/components/admin/stationInfoDetail'
import newList from '@/components/admin/newList'
import admin_addCompany from '@/components/admin/addCompany'
import admin_addProduct from '@/components/admin/addProduct'
import admin_wxUser from '@/components/admin/wxUser'
import reservesList from '@/components/admin/reservesList'
import accountList from '@/components/admin/account'

import cnGlobalList from '@/components/admin/cnGlobalList'
import surveyList from '@/components/admin/surveyList'
import survey_message from '@/components/admin/survey_message'
import survey_other from '@/components/admin/survey_other'


import promotion from '@/components/admin/promotion'
import personList from '@/components/admin/personList'
import short_link from '@/components/admin/ShortLink'
import card from '@/components/admin/card'
import thailand_index from '@/components/admin/tha_liaison/index'

import adminLogin from '@/components/adminLogin'
import manageLogin from '@/components/manageLogin'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [{
        path: '/admin',
        name: 'hw',
        component: HW,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('adminToken')) {
                next({ path: '/admin/index' })
            } else {
                next({ path: '/admin/adminLogin' })
            }
        },
    },
    {
        path: '/',
        name: 'hw',
        component: HW,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('adminToken')) {
                next({ path: '/admin/index' })
            } else {
                next({ path: '/admin/adminLogin' })
            }
        },
    },
    {
        path: '/managelogin',
        name: 'manageLogin',
        component: manageLogin,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('token')) {
                next({ path: '/manage/index' })
            } else {
                next();
            }
        },
    },
    {
        path: '/admin/adminlogin',
        name: 'adminLogin',
        component: adminLogin,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('adminToken')) {
                next({ path: '/admin/index' })
            } else {
                next();
            }
        },
    },

    {
        path: '/manage',
        name: 'Manage',
        component: Manage,
        children: [{
            path: '/manage/index',
            name: 'index',
            component: index,
            meta: {
                title: "首页",
            }
        },
        {
            path: '/manage/infolist',
            name: 'infoList',
            component: infoList,
            meta: {
                title: "展商信息",
            }
        },
        {
            path: '/manage/ex_user',
            name: 'ex_user',
            component: ex_user,
            meta: {
                title: "参展人员",
            }
        },
        {
            path: '/manage/productlist',
            name: 'productList',
            component: productList,
            meta: {
                title: "参展商品",
            }
        },
        {
            path: '/manage/reservelist',
            name: 'reserveList',
            component: reserveList,
            meta: {
                title: "预约客户",
            }
        },

        {
            path: '/manage/hitlist',
            name: 'hitList',
            component: hitList,
            meta: {
                title: "点赞客户",
            }
        },
        {
            path: '/manage/downloadlist',
            name: 'downloadList',
            component: downloadList,
            meta: {
                title: "资料下载",
            }
        },
        {
            path: '/manage/exhibitionlist',
            name: 'exhibitionList',
            component: exhibitionList,
            meta: {
                title: "展会信息",
            }
        },

        {
            path: '/manage/productdetail',
            name: 'productDetail',
            component: productDetail,
            meta: {
                title: "产品详情"
            },
        },
        {
            path: '/manage/infodetail',
            name: 'infoDetail',
            component: infoDetail,
            meta: {
                title: "意见反馈"
            },
        },
        {
            path: '/manage/opinion',
            name: 'opinion',
            component: opinion,
            meta: {
                title: "产品详情"
            },
        },
        {
            path: '/manage/productadd',
            name: 'productAdd',
            component: productAdd,
            meta: {
                title: "产品详情"
            },
        },
        {
            path: '/manage/password',
            name: 'password',
            component: password,
            meta: {
                title: "产品详情"
            },
        },
        {
            path: '/manage/exhibitiondetail',
            name: 'exhibitionDetail',
            component: exhibitionDetail,
            meta: {
                title: "产品详情"
            },
        },


        ],
        meta: { title: "管理员页面" },
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('token')) {
                if (to.path === '/') {
                    next({ path: '/manage/index' })
                }
                if (to.path === '/manage') {
                    next({ path: '/manage/index' })
                }
                if (to.path === '/managelogin') {
                    next({ path: '/managelogin' })
                } else {
                    next()
                }
            } else {
                next({ path: '/managelogin' })
            }
        }
    },
    {
        path: '/',
        name: 'admin',
        component: Admin,
        children: [{
            path: '/admin/index',
            name: 'admin_index',
            component: admin_index,
            meta: {
                title: "管理员后台首页"
            },
        },
        {
            path: '/admin/tha_liaison_index',
            name: 'thailand_index',
            component: thailand_index,
            meta: {
                title: "中泰企业会员增加"
            },

        },


        {
            path: '/admin/companylist',
            name: 'admin_companyList',
            component: admin_companyList,
            meta: {
                title: "展商列表"
            },
        },

        {
            path: '/admin/ex_user',
            name: 'admin_ex_user',
            component: admin_ex_user,
            meta: {
                title: "参展人员",
            }
        },
        {
            path: '/admin/productlist',
            name: 'admin_productList',
            component: admin_productList,
            meta: {
                title: "展品列表"
            },
        },
        {
            path: '/admin/viewerlist',
            name: 'admin_viewerList',
            component: admin_viewerList,
            meta: {
                title: "观众列表"
            },
        },
        {
            path: '/admin/activitylist',
            name: 'admin_activityList',
            component: admin_activityList,
            meta: {
                title: "活动列表"
            },
        },
        {
            path: '/admin/addactivity',
            name: 'admin_addActivity',
            component: admin_addActivity,
            meta: {
                title: "添加活动"
            },
        },
        {
            path: '/admin/activityApply',
            name: 'admin_ActivityApply',
            component: admin_ActivityApply,
            meta: {
                title: "活动申请"
            },
        },
        {
            path: '/admin/addstationinfo',
            name: 'admin_addStationInfo',
            component: admin_addStationInfo,
            meta: {
                title: "添加站内信息"
            },
        },
        {
            path: '/admin/accountmanage',
            name: 'admin_accountManage',
            component: admin_accountManage,
            meta: {
                title: "账号管理"
            },
        },

        {
            path: '/admin/applybooth',
            name: 'admin_applyBooth',
            component: admin_applyBooth,
            meta: {
                title: "展商详情"
            },
        },
        {
            path: '/admin/exhibitordetails',
            name: 'admin_exhibitorDetails',
            component: admin_exhibitorDetails,
            meta: {
                title: "展商详情"
            },


        },
        {
            path: '/admin/productdetail',
            name: 'admin_productDetail',
            component: admin_productDetail,
            meta: {
                title: "产品详情"
            },

        },

        {
            path: '/admin/newlist',
            name: 'newList',
            component: newList,
            meta: {
                title: "展会管理"
            },

        },


        {
            path: '/admin/eventmanage',
            name: 'admin_eventManage',
            component: admin_eventManage,
            meta: {
                title: "展会管理"
            },

        },
        {
            path: '/admin/eventinfo',
            name: 'admin_eventInfo',
            component: admin_eventInfo,
            meta: {
                title: "展会介绍"
            },

        },


        {
            path: '/admin/eventcontent',
            name: 'admin_eventContent',
            component: admin_eventContent,
            meta: {
                title: "展会内容信息"
            },

        },
        {
            path: '/admin/eventtrip',
            name: 'admin_eventTrip',
            component: admin_eventTrip,
            meta: {
                title: "展会行程信息"
            },

        },
        {
            path: '/admin/eventroute',
            name: 'admin_eventRoute',
            component: admin_eventRoute,
            meta: {
                title: "展会路线说明"
            },

        },
        {
            path: '/admin/eventcontact',
            name: 'admin_eventContact',
            component: admin_eventContact,
            meta: {
                title: "展会联系方式"
            },

        },

        {
            path: '/admin/eventdownload',
            name: 'admin_eventDownload',
            component: admin_eventDownload,
            meta: {
                title: "展会资料下载"
            },

        },
        {
            path: '/admin/admanage',
            name: 'admin_adManage',
            component: admin_adManage,
            meta: {
                title: "广告管理"
            },

        },
        {
            path: '/admin/product_vote',
            name: 'admin_product_vote',
            component: admin_product_vote,
            meta: {
                title: "投票管理"
            },

        },
        {
            path: '/admin/viewerdetail',
            name: 'admin_viewerDetail',
            component: admin_viewerDetail,
            meta: {
                title: "观众详情"
            },

        },

        {
            path: '/admin/activitydatail',
            name: 'admin_activityDatail',
            component: admin_activityDatail,
            meta: {
                title: "观众详情"
            },

        },

        {
            path: '/admin/eventMangedetail',
            name: 'admin_eventMangeDetail',
            component: admin_eventMangeDetail,
            meta: {
                title: "观众详情"
            },

        },

        {
            path: '/admin/stationInfodetail',
            name: 'admin_stationInfoDetail',
            component: admin_stationInfoDetail,
            meta: {
                title: "观众详情"
            },

        },
        {
            path: '/admin/addcompany',
            name: 'admin_addCompany',
            component: admin_addCompany,
            meta: {
                title: "添加展商"
            },

        },
        {
            path: '/admin/addproduct',
            name: 'admin_addProduct',
            component: admin_addProduct,
            meta: {
                title: "添加产品"
            },

        },
        {
            path: '/admin/wxuser',
            name: 'admin_wxUser',
            component: admin_wxUser,
            meta: {
                title: "微信用户"
            },

        },
        {
            path: '/admin/account',
            name: 'account',
            component: accountList,
            meta: {
                title: "账号管理"
            },

        },
        {
            path: '/admin/reserveslist',
            name: 'reservesList',
            component: reservesList,
            meta: {
                title: "预约公司"
            },
        },
        {
            path: '/admin/personList',
            name: 'personList',
            component: personList,
            meta: {
                title: "预约公司"
            },
        },

        {
            path: '/admin/card',
            name: 'card',
            component: card,
            meta: {
                title: "名片投递"
            },
        },


        {
            path: '/admin/cnGlobalList',
            name: 'cnGlobalList',
            component: cnGlobalList,
            meta: {
                title: "公司列表"
            },
        },

        {
            path: '/admin/promotion',
            name: 'promotion',
            component: promotion,
            meta: {
                title: "推广活动"
            },
        },

        {
            path: '/admin/short_link',
            name: 'short_link',
            component: short_link,
            meta: {
                title: "推广中文列表"
            },
        },
        {
            path: '/admin/surveyList',
            name: 'surveyList',
            component: surveyList,
            meta: {
                title: "选展器"
            },
        },

        {
            path: '/admin/survey_message',
            name: 'survey_message',
            component: survey_message,
            meta: {
                title: "选展器"
            },
        },

        {
            path: '/admin/survey_other',
            name: 'survey_other',
            component: survey_other,
            meta: {
                title: "选展器"
            },
        },


        ],
        meta: { title: "管理员页面" },
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('adminToken')) {
                if (to.path === '/admin' || to.path === '/admin/') {
                    next({ path: '/admin/index' })
                } else {
                    next()
                }
            } else {
                next({ path: '/admin/adminlogin' })
            }
        }
    }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js